import n, { forwardRef as s } from "react";
import { cls as f } from "../../helpers/cls.js";
import { XCircle as O } from "@olxbr/ds-icons";
import { Text as d } from "../Text/Text.js";
import { Flex as C } from "../Flex/Flex.js";
var w = Object.defineProperty,
  m = Object.getOwnPropertySymbols,
  _ = Object.prototype.hasOwnProperty,
  b = Object.prototype.propertyIsEnumerable,
  u = (e, o, r) => o in e ? w(e, o, {
    enumerable: !0,
    configurable: !0,
    writable: !0,
    value: r
  }) : e[o] = r,
  c = (e, o) => {
    for (var r in o || (o = {})) _.call(o, r) && u(e, r, o[r]);
    if (m) for (var r of m(o)) b.call(o, r) && u(e, r, o[r]);
    return e;
  },
  p = (e, o) => {
    var r = {};
    for (var l in e) _.call(e, l) && o.indexOf(l) < 0 && (r[l] = e[l]);
    if (e != null && m) for (var l of m(e)) o.indexOf(l) < 0 && b.call(e, l) && (r[l] = e[l]);
    return r;
  };
typeof window != "undefined" && !window.__DS_WEB_VERSION__ && (window.__DS_WEB_VERSION__ = "3.35.0");
const E = s((e, o) => {
  var r = e,
    {
      hasError: l,
      className: t,
      children: a
    } = r,
    i = p(r, ["hasError", "className", "children"]);
  return a ? n.createElement(d.Caption, c(c({
    tag: "span",
    className: f("olx-form-control__bottom-left", t),
    ref: o,
    color: l ? "--color-feedback-error-100" : "--color-neutral-120"
  }, l && {
    role: "alert"
  }), i), l && n.createElement(O, {
    size: "16px"
  }), a) : null;
});
E.displayName = "FormControlErrorORCaption";
const N = s((e, o) => {
  var r = e,
    {
      children: l,
      className: t,
      size: a
    } = r,
    i = p(r, ["children", "className", "size"]);
  const y = a === "medium" ? d.BodyMedium : d.BodySmall;
  return l ? n.createElement(y, c({
    tag: "label",
    className: f("olx-form-control__label", t),
    weight: "semibold",
    ref: o
  }, i), l) : null;
});
N.displayName = "FormControlLabel";
const v = s((e, o) => {
  var r = e,
    {
      children: l,
      className: t
    } = r,
    a = p(r, ["children", "className"]);
  return n.createElement(C, c({
    "data-ds-component": "DS-FormControl",
    className: f("olx-form-control", t),
    justifyContent: "space-between",
    alignItems: "center",
    ref: o
  }, a), l);
});
v.displayName = "FormControl";
export { v as FormControl, E as FormControlErrorORCaption, N as FormControlLabel };